<mds-dropdown-new
    [formCtrl]="formControl"
    [multiple]="false"
    [filterable]="false"
    [clearable]="false"
    [options]="options()"
    [selectAllText]="selectAllText()"
/>
